import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { select, Store } from '@ngrx/store';
import { SaveMission } from '../../../store/actions/mission.actions';
import { AddressInterface } from '../../../../account/models/address.interface';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { AddressInterfaceState } from '../../../../account/store/state/address.state';
import { LineInterface } from '../../../../lines/models/line.interface';
import { PriceDetailsInterface } from '../../../models/price-details.interface';
import { ExtranetService } from '../../../services/extranet.service';
import { SupportUserInterface } from '../../../models/support-user.interface';
import { SimChoiceInterface } from '../../../models/sim-choice.interface';
import { SimChoiceInterfaceState } from '../../../store/state/sim-choice.state';
import { UpdateSimChoice } from '../../../store/actions/sim-choice.actions';
import { UpdateMfaVisibility } from '../../../store/actions/mfa.actions';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-order-sim-card',
  templateUrl: './order-sim-card.component.html',
  styleUrls: ['./order-sim-card.component.css'],
  standalone: false
})
export class OrderSimCardComponent implements OnInit {

  step: number;
  steps: number;
  simChoiceInterface: SimChoiceInterface;
  brand?: string;

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  shippingAddress: AddressInterface|null;
  supportUser: SupportUserInterface|null;
  isFreeSwap: boolean;

  constructor(
      private store: Store<any>,
      private extranetService: ExtranetService
  ) {}

  ngOnInit() {
    this.shippingAddress = null;
    this.brand = environment.data.brand;
    this.supportUser = this.extranetService.getSupportUser();
    this.isFreeSwap = false;
    this.step = 1;
    this.steps =  this.supportUser ? 3 : 2;
    this.simChoiceInterface = {
      esimPhone: null,
      simChoice: 4,
      displayErrorMessage: false
    } as SimChoiceInterface;

    this.store.pipe(select(ConstsHelper.REDUCER_ADDRESS)).subscribe( (result: AddressInterfaceState) => {
      if (null != result.address) {
        for (const addr of result.address) {
          if (addr.isPrincipal) {
            this.shippingAddress = addr;
          }
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_SIM_CHOICE)).subscribe((response: SimChoiceInterfaceState) => {
      if (null !== response.simChoice) {
        this.simChoiceInterface = response.simChoice;
      }
    });
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number) {
    if (step === 3 && this.simChoiceInterface.displayErrorMessage === true) {
      this.simChoiceInterface.displayErrorMessage = true;
      this.store.dispatch(new UpdateSimChoice(this.simChoiceInterface));
    } else {
      this.step = step;
    }
  }

  updateSwap(swap: boolean) {
    this.isFreeSwap = swap;
    this.confirmation();
  }

  confirmation() {
    const orderSimCardInterface = {
      step: 1,
      phoneNumber: this.line.phoneNumber,
      simType: this.simChoiceInterface.simChoice,
      esimPhone: null,
      shippingAddressId: this.shippingAddress ? this.shippingAddress.id : null
    };
    let object = orderSimCardInterface as any;
    if (this.isFreeSwap && this.supportUser) {
      object = {...orderSimCardInterface, isFreeSwap: this.isFreeSwap};
    }

    if (this.supportUser || orderSimCardInterface.simType === 4) {
      this.store.dispatch(new SaveMission(object, this.procedureCode));
    } else {
      this.store.dispatch(
          new UpdateMfaVisibility(
              {
                visibility: true,
                action: this.procedureCode,
                step: 1,
                destination: this.line.phoneNumber,
                code: null,
                errorMessage: null,
                effect: SaveMission,
                effectData: object
              }
          )
      );
    }
  }
}
